import { Injectable } from '@angular/core';
import { Order } from 'src/app/models/order.model';
import { AlertQueueService } from '../../../utils/prompt-queue/alert-queue.service';
import { HubAlertModule } from '../../../utils/prompt-queue/alert-queue.module.constant';

import size from 'lodash/size';
import { DocketService } from 'src/app/api/core/docket/docket.service';

@Injectable({
  providedIn: 'root',
})
export class HandleFailedDispatchService {
  constructor(public alertQueue: AlertQueueService, public docketService: DocketService) {}

  /**
   * Handle the failed request of the bump and eta requests
   * @param order - The order with failed request
   * @param method - The type of request that failed
   * @param errorMsg - Optional. The error message to use.
   * @param data - Optional. Additional data to accompany the order
   */
  async handleFailedUpdateRequest(order: Order, method: string, errorMsg?: string, data?: any) {
    let title: string;
    let message: string;

    switch (method) {
      case 'bump':
        title = 'Completing Order failed';
        message = `Sorry, you'll need to try and complete the order ${order.id} again.`;
        break;

      case 'unbump':
        title = 'Reopening Order failed';
        message = `Sorry, you'll need to try and reopen order ${order.id} again.`;
        break;

      case 'eta':
        title = 'ETA Request failed';
        message = size(errorMsg) ? errorMsg : `Sorry, you'll need to set the ETA on docket ${order.id} again.`;
        break;

      case 'confirm':
        title = 'Confirmation failed';
        message = size(errorMsg) ? errorMsg : `Sorry, you'll need to confirm docket ${order.id} again.`;
        break;

      case 'sms':
        // check the message contains 'identical SMS sent for this order'
        if (data && data.error && data.error.includes('identical SMS sent for this order')) {
          title = 'SMS failed';
          message = `Maximum number of messages have been sent already.`;
          break;
        }

        title = 'SMS failed';
        message = `Sorry, you'll need to send the SMS for docket ${order.id} again.`;
        break;
      default:
      //nothing
    }

    await this.alertQueue.createAndQueue(
      {
        header: title,
        message: message,
        buttons: ['Continue'],
      },
      HubAlertModule.FAILED_ORDER_UPDATE,
      true,
    );

    this.docketService.resetDocket(order.id, method, data);
  }
}
